import { render, staticRenderFns } from "./JoinWrapper.vue?vue&type=template&id=3045e834&"
import script from "./JoinWrapper.vue?vue&type=script&lang=ts&"
export * from "./JoinWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./JoinWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports